export default "__VITE_ASSET__CaPRXIPq__"